import {
  DEFAULT_FORMAT,
  getDate,
  getDateInUserLocale
} from "@/helpers/date.helpers"

export function toSelectionOption(value: Jira.AllowedValue) {
  return {
    value: value.id,
    label: value.value ?? value.name ?? value.id
  }
}

export const removeBTags = (str: string) => str.replace(/<b>|<\/b>/g, "")

export function calculateOnDemandDateFieldHint(props: {
  value: number | undefined
  fieldName: string
  dayTrans: string
  t: (key: string, options?: any) => string
  isRequired?: boolean
}) {
  const { value: intValue, fieldName, dayTrans, t, isRequired } = props

  if (intValue === undefined || intValue === null) {
    return t(
      isRequired ? "dateField.requiredNoValueHint" : "dateField.noValueHint",
      { fieldName }
    )
  }
  // Calculate example dates
  const today = getDate()
  const futureDate = today.add(intValue, "day")

  return t("dateField.valueHint", {
    fieldName,
    dayTrans,
    value: intValue,
    triggerDate: getDateInUserLocale(today, DEFAULT_FORMAT),
    valueDate: getDateInUserLocale(futureDate, DEFAULT_FORMAT)
  })
}

export function formatFieldName(fieldName: string): string {
  return fieldName.toLowerCase().replace(/\s+/g, "_")
}
